import { API } from "./api";

const KEY = "rd_sid";
let utmCache = null;
let startTs = Date.now();

export const getSessionId = () => {
  let sid = localStorage.getItem(KEY);
  if (!sid) {
    sid = `${Date.now()}-${crypto.randomUUID()}`;
    localStorage.setItem(KEY, sid);
  }
  return sid;
};

const getUtm = () => {
  if (utmCache) return utmCache;
  const p = new URLSearchParams(window.location.search);
  utmCache = {
    utm_source: p.get("utm_source") || "",
    utm_medium: p.get("utm_medium") || "",
    utm_campaign: p.get("utm_campaign") || "",
  };
  return utmCache;
};

const basePayload = (type, meta) => ({
  type,
  session_id: getSessionId(),
  page: window.location.pathname + window.location.hash,
  referrer: document.referrer || "",
  tz: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
  vw: window.innerWidth,
  ua: navigator.userAgent,
  ...getUtm(),
  meta,
});

export const trackEvent = (type, meta = {}) => {
  try {
    fetch(`${API}/events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(basePayload(type, meta)),
      keepalive: true,
    });
  } catch {}
};

export const trackPage = () => trackEvent("page_view");

window.addEventListener("pagehide", () => {
  try {
    navigator.sendBeacon(
      `${API}/events`,
      new Blob([JSON.stringify(basePayload("session_end", { duration_s: Math.round((Date.now() - startTs) / 1000) }))], { type: "application/json" })
    );
  } catch {}
});
